export const notificationContainer: CSSFunction = () => ({
  gap: '16px',
  flexDirection: 'column',
  position: 'absolute',
  top: '10px',
  right: '8px',
  zIndex: 1000,
});
